import { create } from "zustand";

/**
 * Выбранная ступень порога оборота в сводке по группам — общая на всю вкладку.
 *
 * Стор, а не useState, по той же причине, что у окна статистики: рынки короткие,
 * и локальное состояние сбрасывало бы выбор при каждом переходе.
 *
 * Порог НЕ уезжает в запрос вовсе: сервер присылает разбиение сразу по всей
 * лестнице, а здесь выбирается уже приехавшее. Отсюда главное свойство этого
 * переключателя — у него не бывает расхождения «нажато одно, показано другое»,
 * за которое соседние два в этой же панели платят жёлтой припиской. И смена
 * порога ничего не стоит: ни запроса, ни мигания таблицы, ни гонки с опросом.
 *
 * Без записи в localStorage, и это осознанно — довод тот же, что у useFlowWindow:
 * умолчание задаёт СЕРВЕР (default_min_turnover_usd в ответе), а сохранённая
 * копия стала бы вторым местом, где живёт то же значение.
 *
 * `undefined` означает «оператор не выбирал»: показывается серверное умолчание.
 */
interface CohortFloorStore {
  /** Порог в долларах строкой — ключ ступени. Пусто — умолчание сервера. */
  picked: string | undefined;
  pick: (usd: string) => void;
}

export const useCohortFloor = create<CohortFloorStore>((set) => ({
  picked: undefined,
  pick: (usd) => set({ picked: usd }),
}));
